export const findFriendNoteTemplates = [
  "A note that says: find ",
  "A wanted poster for ",
  "A hastily scribbled message: find ",
  "An official-looking document requesting you find ",
  "A crumpled piece of paper that says: please locate ",
  "A child's drawing of a man, labeled ",
  "A picture of ",
  "A printed out email begging you to find ",
  "A silver bracelet inscribed with a name: ",
  "A pewter bust in the shape of ",
  "A Polaroid photo of a man, labeled ",
  "An old-fashioned calling card that says ",
  "A newspaper clipping about someone named ",
  "A message about tracking down ",
  "A typewritten message: please find ",
  "A quest to track down ",
  "A high school year book, with one photo circled: ",
];
